import styled from '@emotion/styled';

import PreviewAbleImage from '../../PreviewAbleImage/PreviewAbleImage';
import TableSliderContentWrapper from '../TableAccessories/TableSliderContentWrapper';

interface ViewBADriverInfoProps {
  data?: Record<string, any>;
}

const ViewBADriverInfo: React.FC<ViewBADriverInfoProps> = ({ data }) => {
  // const tableContext = useContext(TableContext);

  return (
    <TableSliderContentWrapper label='Driver Profile'>
      <Cell className='vertical'>
        <CellLabel>Image</CellLabel>
        <ImageWrapper>
          <Img src={data?.profilePicture ?? ''} alt='Driver profile picture' />
        </ImageWrapper>
      </Cell>

      {/* section 1 */}
      <Section>
        <Cell>
          <CellLabel>Name</CellLabel>
          <div>{`${data?.firstName} ${data?.lastName}`}</div>
        </Cell>
        <Cell>
          <CellLabel>Gender</CellLabel>
          <div>{data?.gender ?? ''}</div>
        </Cell>
        <Cell>
          <CellLabel>NIN Status</CellLabel>
          <div>{data?.ninStatus ?? '--'}</div>
        </Cell>
        <Cell>
          <CellLabel>Date of Birth</CellLabel>
          <div>{data?.dateOfBirth ?? ''}</div>
        </Cell>
        <Cell>
          <CellLabel>Email Address</CellLabel>
          <div>{data?.email ?? '--'}</div>
        </Cell>
        <Cell>
          <CellLabel>Home Address</CellLabel>
          <div>{data?.address ?? ''}</div>
        </Cell>

        <Space>
          <Divider> </Divider>
        </Space>
        {/* section 2 */}

        <Cell>
          <CellLabel>Vehicles Operated</CellLabel>
          <div> {data?.fleetTypes?.join(', ') ?? '--'}</div>
        </Cell>
        <Cell>
          <CellLabel>Previous Workplace</CellLabel>
          <div>{data?.previousEmployer ?? '--'}</div>
        </Cell>
        <Cell>
          <CellLabel>Start Date at Previous Workplace</CellLabel>
          <div>{data?.employementStartDate ?? '--'}</div>
        </Cell>

        <Space></Space>

        <PreviewAbleImage imgUrl={`${data?.driverCard ?? ''}`} />
      </Section>
    </TableSliderContentWrapper>
  );
};

export default ViewBADriverInfo;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* border: 1px solid red; */
  background-color: rgba(250, 250, 250, 0.8);
  padding: 12px;
`;

const Cell = styled.div`
  display: flex;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #2f3644;
  justify-content: space-between;

  &.vertical {
    flex-direction: column;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: fit-content;
  padding: 8px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 8px;
  cursor: crosshair;
`;

const Img = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 8px;
  object-fit: cover;
`;

const CellLabel = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.darkGrayText};
  /* border: 1px solid blue; */
`;

const Space = styled.div`
  padding: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Divider = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};
  width: 80%;
`;
